module.exports = __webpack_public_path__ + "static/img/section10_content1_bg1.aa45b27e.png";